import { m } from "framer-motion";
// @mui
import { Container, Typography } from "@mui/material";
// components
import { MotionContainer, varBounce } from "../components/animate";
// assets
import { ForbiddenIllustration } from "../assets/illustrations";
//
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";

// ----------------------------------------------------------------------

type RoleBasedGuardProp = {
  hasContent?: boolean;
  roles?: string[]; // permissões necessárias para acessar
  children: React.ReactNode;
};

export default function RoleBasedGuard({
  hasContent,
  roles,
  children,
}: RoleBasedGuardProp) {
  // Pega os módulos/permissões do usuário
  const authState = useSelector((state: RootState) => state.auth);
  const userRoles: string[] =
    authState.userReturn.modules?.map((m: any) =>
      typeof m === "string" ? m.toLowerCase() : m.name?.toLowerCase()
    ) || [];

  const hasPermission =
    !roles || roles.some((role) => userRoles.includes(role.toLowerCase()));

  if (!hasPermission) {
    return hasContent ? (
      <Container component={MotionContainer} sx={{ textAlign: "center" }}>
        <m.div variants={varBounce().in}>
          <Typography variant="h3" paragraph>
            Acesso Negado
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <Typography sx={{ color: "text.secondary" }}>
            Você não possui permissão para acessar está página
          </Typography>
        </m.div>

        <m.div variants={varBounce().in}>
          <ForbiddenIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
        </m.div>
      </Container>
    ) : null;
  }

  return <>{children}</>;
}
